import { useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import { AdminFilterBar } from "@/components/admin/AdminFilterBar";
import { AdminDetailPanel } from "@/components/admin/AdminDetailPanel";
import { Download } from "lucide-react";

export function AdminDrilldownWorkspace({ title, items = [], emptyText = "No records found.", onSelect, renderDetail, testId = "admin-drilldown-workspace" }) {
  const [query, setQuery] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const filteredItems = useMemo(() => items.filter((item) => [item.title, item.subtitle].filter(Boolean).join(" ").toLowerCase().includes(query.toLowerCase())), [items, query]);

  const exportCsv = () => {
    const header = "id,title,subtitle\n";
    const rows = filteredItems.map((item) => `${item.id},${(item.title || "").replace(/,/g, " ")},${(item.subtitle || "").replace(/,/g, " ")}`);
    const blob = new Blob([header + rows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}.csv`;
    a.click();
  };

  return (
    <div className="space-y-4" data-testid={testId}>
      <AdminFilterBar
        searchValue={query}
        onSearchChange={setQuery}
        searchPlaceholder={`Search ${title.toLowerCase()}...`}
        activeFilters={query ? [{ key: "search", label: `Search: ${query}`, onRemove: () => setQuery("") }] : []}
        onClearAll={() => setQuery("")}
        extraActions={<Button variant="outline" onClick={exportCsv} data-testid={`${testId}-export-btn`}><Download className="w-4 h-4 mr-2" />Export CSV</Button>}
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 lg:gap-6 border border-zinc-200 bg-white">
        <div className="lg:col-span-8 border-r border-zinc-200">
          {filteredItems.length === 0 ? <div className="p-8 text-center text-zinc-500">{emptyText}</div> : filteredItems.map((item) => (
            <button key={item.id} type="button" className="w-full px-6 py-4 border-b border-zinc-200 hover:bg-zinc-50 text-left transition-colors" onClick={() => { setSelectedItem(item); onSelect?.(item); }} data-testid={`${testId}-row-${item.id}`}>
              <p className="font-medium text-zinc-900">{item.title}</p>
              <p className="text-xs text-zinc-500 mt-1">{item.subtitle}</p>
            </button>
          ))}
        </div>
        <div className="lg:col-span-4">
          <AdminDetailPanel title={selectedItem?.title} subtitle={selectedItem?.subtitle} testId={`${testId}-detail-panel`}>
            {selectedItem ? renderDetail?.(selectedItem) : null}
          </AdminDetailPanel>
        </div>
      </div>
    </div>
  );
}